export enum VossProductGroupTagType {
    Migration = 0,
    Exclusive = 1,
}

export const VossProductGroupTagTypeText: Record<VossProductGroupTagType, string> = {
    [VossProductGroupTagType.Migration]: 'vossProductGroupTagType.migration',
    [VossProductGroupTagType.Exclusive]: 'vossProductGroupTagType.exclusive',
};

export const VossProductGroupTagTypeDescription: Record<VossProductGroupTagType, string> = {
    [VossProductGroupTagType.Migration]: 'vossProductGroupTagType.migrationDescription',
    [VossProductGroupTagType.Exclusive]: 'vossProductGroupTagType.exclusiveDescription',
};

export const productGroupTagTypes = Object.keys(VossProductGroupTagTypeText).map(Number) as VossProductGroupTagType[];
